import {
    NOTIFICATION_TYPE,
    DefaultNotificationData,
    NotificationDataType,
    Notification,
} from '@yandex-int/k-common/typings/api/models';

const DEFAULT_NOTIFICATION_DATA_SLUGS = [
    NOTIFICATION_TYPE.TEAM_UPDATED,
    NOTIFICATION_TYPE.TEAM_DELETED,
    NOTIFICATION_TYPE.TEAM_ARCHIVED,
    NOTIFICATION_TYPE.TEAM_UNARCHIVED,
    NOTIFICATION_TYPE.TEAM_ACCESS_REVOKED,
    NOTIFICATION_TYPE.SCHOOL_CODE_UPDATED,
    NOTIFICATION_TYPE.STREAM_LESSONS_CANCELLED,
    NOTIFICATION_TYPE.MESSENGER_CLOSING,
    NOTIFICATION_TYPE.MESSENGER_CLOSED,
    NOTIFICATION_TYPE.WEBINAR_INVITATION,
];

export function isSchoolCodeUpdatedNotification(
    notification: Notification<NotificationDataType>
): notification is Notification<DefaultNotificationData> {
    return notification.type_slug === NOTIFICATION_TYPE.SCHOOL_CODE_UPDATED;
}

export function isDefaultDataNotification(
    notification: Notification<NotificationDataType>
): notification is Notification {
    return DEFAULT_NOTIFICATION_DATA_SLUGS.includes(notification.type_slug);
}
